import { madeRequest } from '../../helpers/api'
import { replaceRouteParams } from '../../helpers/url'

import { UpdateAdStatusPayload } from '../types/ads'
import { listItemChangeStatus } from '../../constants/other'
import { ENDPOINT_PLATFORM, ENDPOINTS } from '../../constants/api'

// PLOP_APPEND_PATTERN_ANCHOR
// type GetAdsServicePayload = (params: object, platform: number) => void
// export async function getAdsService(params, platform): Promise<GetAdsServicePayload> {
export async function getAdsService(params: object, platform: string) {
  return madeRequest('GET', {
    params,
    url: replaceRouteParams(ENDPOINTS.ads, { platform: ENDPOINT_PLATFORM[platform] })
  })
}

export async function getAdService({ id, ...params }: { id: string; [key: string]: any }, platform: string) {
  // const { id, ...params } = allParams
  return madeRequest('GET', {
    params,
    url: replaceRouteParams(ENDPOINTS.ad, {
      id,
      platform: ENDPOINT_PLATFORM[platform]
    })
  })
}

export async function createAdService(adData: object, platform: string) {
  return madeRequest('POST', {
    data: adData,
    url: replaceRouteParams(ENDPOINTS.ads, {
      platform: ENDPOINT_PLATFORM[platform]
    })
  })
}

export async function validateAdService(adData: object, platform: string) {
  return madeRequest('POST', {
    params: {
      requestAction: 'validate'
    },
    data: adData,
    url: replaceRouteParams(ENDPOINTS.ads, {
      platform: ENDPOINT_PLATFORM[platform]
    }),
    showErrorToast: false
  })
}

export function createAdsBatchService(adData: object, platform: string) {
  return madeRequest('POST', {
    data: adData,
    url: replaceRouteParams(`${ENDPOINTS.ads}batch_create/`, { platform: ENDPOINT_PLATFORM[platform] })
  })
}

export function updateAdService(adData: object, id: string, platform: string, requestMethod = 'PATCH') {
  return madeRequest(requestMethod, {
    data: adData,
    url: replaceRouteParams(ENDPOINTS.ad, {
      id,
      platform: ENDPOINT_PLATFORM[platform]
    })
  })
}

export function updateAdStatusService({ id, adAccountId, status, platform }: UpdateAdStatusPayload['updateData']) {
  const url = replaceRouteParams(ENDPOINTS.ad, { id, platform: ENDPOINT_PLATFORM[platform] })

  return madeRequest('POST', {
    data: { account: adAccountId },
    url: `${url}${status === listItemChangeStatus.paused.changeTo ? 'activate' : 'pause'}/`
  })
}

export function deleteAdService(id: string, params: object, platform: string) {
  return madeRequest('DELETE', {
    params,
    url: replaceRouteParams(ENDPOINTS.ad, {
      id,
      platform: ENDPOINT_PLATFORM[platform]
    })
  })
}

export function copyAdService(data: object, adId: string, platform: string) {
  return madeRequest('POST', {
    data,
    url: replaceRouteParams(ENDPOINTS.copyAd, {
      id: adId,
      platform: ENDPOINT_PLATFORM[platform]
    })
  })
}

export function deleteInternalAdService(adId: string, platform: string) {
  return madeRequest('DELETE', {
    url: replaceRouteParams(`${ENDPOINTS.internalAds}${adId}/`, {
      platform: ENDPOINT_PLATFORM[platform]
    })
  })
}

export function approveInternalAdService(adId: string) {
  return madeRequest('POST', {
    url: `${ENDPOINTS.internalAds}${adId}/approve/`
  })
}

export function disapproveInternalAdService(adId: string, data: object) {
  return madeRequest('POST', {
    data,
    url: `${ENDPOINTS.internalAds}${adId}/disapprove/`
  })
}

export async function getFacebookPostsService({
  facebookPageId,
  ...params
}: {
  facebookPageId: string
  [key: string]: any
}) {
  return madeRequest('GET', {
    params,
    url: replaceRouteParams(ENDPOINTS.facebookPosts, {
      facebookPageId
    })
  })
}
